import React from 'react'

interface UploadDocumentsDialogContextType {
  filesToBeDeleted: string[]
  filesToUpdate?: number
}

export const UploadDocumentsDialogContext = React.createContext<UploadDocumentsDialogContextType>({
  filesToBeDeleted: [],
  filesToUpdate: 0,
})
